var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNightModeIllu(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "179px",
    height: "120px",
    viewBox: "0 0 179 120",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "night-mode-illu") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.22473737,0 L172.523388,0 C172.523388,0 167.600569,5.2435861 160.462482,5.2435861 L12.2856429,5.2435861 C4.90141502,5.2435861 0.22473737,0 0.22473737,0 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-0.6%",
    y: "-19.1%",
    width: "101.2%",
    height: "138.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -2,
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.578603316   0 0 0 0 0.578603316   0 0 0 0 0.578603316  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1",
    result: "shadowMatrixInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -2,
    in: "SourceAlpha",
    result: "shadowOffsetInner2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner2",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.502577594   0 0 0 0 0.502577594   0 0 0 0 0.502577594  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner2",
    result: "shadowMatrixInner2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner2"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-0.3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Error-OpeningTime",
    transform: "translate(-631.000000, -151.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "night-mode-illu",
    transform: "translate(631.000000, 151.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "//-MacBook-Grey"
  }, /*#__PURE__*/React.createElement("g", {
    id: "::-base",
    transform: "translate(0.000000, 102.249929)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#AFAFAF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "lip",
    fill: "#6F6F6F",
    x: 75.2977207,
    y: 0,
    width: 24.6140929,
    height: 2.62179305
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.685307,1.68122318 C18.685307,0.752709255 19.4436144,0 20.3783711,0 L154.831163,0 C155.766217,0 156.524227,0.756351485 156.524227,1.68122318 L156.524227,95.6954463 L18.685307,95.6954463 L18.685307,1.68122318 Z",
    id: "screen-bg",
    fill: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "screen-bottom",
    fill: "#555555",
    opacity: 0.589493937,
    x: 18.685307,
    y: 95.6954463,
    width: 137.83892,
    height: 6.55448262
  }), /*#__PURE__*/React.createElement("rect", {
    id: "macbook-label",
    fill: "#505050",
    x: 80.2205393,
    y: 98.3172394,
    width: 14.7684557,
    height: 1.31089652
  }), /*#__PURE__*/React.createElement("g", {
    id: "::-screen",
    transform: "translate(26.069535, 9.176276)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "wallpaper",
    fill: "#021671",
    x: 0,
    y: 0,
    width: 123.070464,
    height: 82.5864811
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6939543,15 C46.4999778,18.6530283 40,27.6301868 40,38.1254964 C40,51.8633054 51.1366946,63 64.8745036,63 C73.6561441,63 81.3749252,58.449358 85.8013464,51.5775746 C82.9608905,52.7061685 79.8632964,53.3265819 76.620797,53.3265819 C62.882988,53.3265819 51.7462934,42.1898873 51.7462934,28.4520783 C51.7462934,23.4959097 53.1957776,18.8782864 55.6939543,15 L55.6939543,15 Z",
    id: "Combined-Shape",
    fill: "#FFD633"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "glare",
    fillOpacity: 0.12,
    fill: "#FFFFFF",
    points: "0 0 77.5343926 0 0 82.5864811"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "webcam",
    fill: "#757575",
    cx: 88.2201195,
    cy: 4.58813784,
    rx: 1,
    ry: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(118.016529, 16.859504)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "display_bg",
    fill: "#021671",
    x: 2.93313298,
    y: 9.80561052,
    width: 54.2629602,
    height: 80.4423234,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4626362,31 C21.3333185,33.4353522 17,39.4201245 17,46.4169976 C17,55.5755369 24.4244631,63 33.5830024,63 C39.4374294,63 44.5832835,59.9662387 47.5342309,55.3850498 C45.6405937,56.1374457 43.575531,56.5510546 41.4138647,56.5510546 C32.2553253,56.5510546 24.8308623,49.1265915 24.8308623,39.9680522 C24.8308623,36.6639398 25.7971851,33.5855243 27.4626362,31 L27.4626362,31 Z",
    id: "Combined-Shape-Copy",
    fill: "#FFD633"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.93313298,10.2679591 C2.93313298,10.012611 3.09856534,9.80561052 3.30126952,9.80561052 L56.8279566,9.80561052 C57.0312728,9.80561052 57.1960932,10.0154539 57.1960932,10.2679591 L57.1960932,90.2479339 L2.93313298,90.2479339 L2.93313298,10.2679591 Z M3.66641623,10.7355796 L3.66641623,88.8799907 L56.4628099,88.8799907 L56.4628099,10.7355796 L3.66641623,10.7355796 Z",
    id: "display_frame",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("g", {
    id: "phone-case"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,0 L57.4958678,0 C59.152722,-3.04359188e-16 60.4958678,1.34314575 60.4958678,3 L60.4958678,100.140496 C60.4958678,101.79735 59.152722,103.140496 57.4958678,103.140496 L3,103.140496 L3,103.140496 C1.34314575,103.140496 2.02906125e-16,101.79735 0,100.140496 L0,3 L0,3 C-2.02906125e-16,1.34314575 1.34314575,3.04359188e-16 3,0 L3,0 Z M2.93313298,10.8013487 L2.93313298,88.7074395 C2.93313298,89.2538468 3.38080343,89.7031777 3.93303292,89.7031777 L56.1961932,89.7031777 C56.7432852,89.7031777 57.1960932,89.2573706 57.1960932,88.7074395 L57.1960932,10.8013487 C57.1960932,10.2549415 56.7484227,9.80561052 56.1961932,9.80561052 L3.93303292,9.80561052 C3.38594093,9.80561052 2.93313298,10.2514177 2.93313298,10.8013487 Z",
    id: "phone-shape",
    fill: "#4C4C4D"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mic",
    fill: "#333333",
    x: 24.2016575,
    y: 5.10075484,
    width: 12.0991736,
    height: 1.8158538,
    rx: 0.9079269
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mic-copy",
    fill: "#333333",
    x: 23.3341204,
    y: 93.6859504,
    width: 13.8276269,
    height: 4.29752066,
    rx: 2.14876033
  }), /*#__PURE__*/React.createElement("g", {
    id: "camera",
    transform: "translate(49.129977, 4.358049)",
    fill: "#333333"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-242-Copy",
    transform: "translate(6.232908, 1.815854) scale(-1, 1) translate(-6.232908, -1.815854) ",
    x: 4.39969947,
    y: 0,
    width: 3.66641623,
    height: 3.6317076,
    rx: 1.8158538
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-242-Copy-2",
    transform: "translate(0.733283, 1.815854) scale(-1, 1) translate(-0.733283, -1.815854) ",
    x: -8.66171332e-13,
    y: 1.08951228,
    width: 1.46656649,
    height: 1.45268304,
    rx: 0.72634152
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNightModeIllu);
export default __webpack_public_path__ + "static/media/night-mode-illu.17f7be40066adf78da1e09d5fe15582e.svg";
export { ForwardRef as ReactComponent };